import { Button } from '@workspace/ui/components/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@workspace/ui/components/dialog'
import { Textarea } from '@workspace/ui/components/textarea'
import { useState } from 'react'

interface ConnectDialogProps {
  startupName: string
  open: boolean
  onOpenChange: (open: boolean) => void
  onConnect: (message?: string) => Promise<void> | void
  isPending: boolean
}

export function ConnectDialog({
  startupName,
  open,
  onOpenChange,
  onConnect,
  isPending,
}: ConnectDialogProps) {
  const [message, setMessage] = useState('')

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Connect with {startupName}</DialogTitle>
          <DialogDescription>
            Send a message to the team. They'll receive your contact details.
          </DialogDescription>
        </DialogHeader>
        <Textarea
          placeholder="Hi, I'd love to learn more about your startup..."
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          rows={4}
        />
        <DialogFooter>
          <Button variant="outline" size="sm" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button size="sm" disabled={isPending} onClick={() => onConnect(message || undefined)}>
            {isPending ? 'Sending...' : 'Send Request'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
